import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=c2f949ae&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=ts"
export * from "./GoodsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f949ae",
  null
  
)

export default component.exports